import { createFileRoute, redirect } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { SpSidebar } from '../components/Sidebar';
import { getAuthStore } from '../main';
import { SubmissionsView } from '../components/SubmissionsView';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/view-submissions')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();

    const isAuthenticated = getAuthStore().getIsAuthenticated();
    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    const userRole = getAuthStore().getUser()?.role;
    if (userRole !== 'artist') {
      throw redirect({ to: '/' });
    }
  },
  component: ViewSubmissions,
});

function ViewSubmissions() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <SpSidebar />
        <Pane classes={'sp-main'} tag="main">
          <h1 style={{ marginBlockEnd: 'var(--spacing-static-5)' }}>
            View Your Submissions
          </h1>
          <SubmissionsView />
        </Pane>
      </div>
    </>
  );
}
